// Shared Ottoman/Arabic script detection utility.
// Used by lexiqamus_search_bar_controller and lexiqamus_word_decoder_controller.
//
// Unicode ranges covered:
//   \u0600-\u06FF  Arabic block (core letters/marks)
//   \u0750-\u077F  Arabic Supplement
//   \u08A0-\u08FF  Arabic Extended-A
//   \uFB50-\uFDFF  Arabic Presentation Forms-A (contextual/ligature forms)
//   \uFE70-\uFEFF  Arabic Presentation Forms-B (additional contextual forms)
const OTTOMAN_SCRIPT_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/

export function isOttomanText(text) {
  if (text == null || typeof text !== "string") return false
  return OTTOMAN_SCRIPT_REGEX.test(text)
}
